import React, { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { Box, Divider, Grid, Hidden, makeStyles, Paper, Typography } from '@material-ui/core'

import * as actions from '../actionTypes'
import LoginForm from '../components/LoginForm'
import researchImage from '../assets/research.png'
import researchImage2x from '../assets/research@2x.png'

const useStyles = makeStyles((theme) => ({
  container: {
    [theme.breakpoints.up('lg')]: {
      margin: '50px auto',
      alignItems: 'center',
      height: 'calc(100% - 164px)',
    },
    [theme.breakpoints.down('md')]: {
      padding: 0,
    },
  },
  heading: {
    fontSize: theme.typography.pxToRem(40),
    fontWeight: 'bolder',
    [theme.breakpoints.down('md')]: {
      fontSize: theme.typography.pxToRem(24),
    },
  },
  paper: {
    height: 630,
    margin: 'auto',
    width: 1364,
    [theme.breakpoints.down('md')]: {
      boxShadow: 'none',
      padding: theme.spacing(4),
      borderRadius: '0',
    },
    overflow: 'hidden',
  },
  imageSide: {
    flex: '0 1 756px',
  },
  formSide: {
    maxWidth: 405,
    margin: 'auto',
  },
  image: {
    display: 'block',
    width: '100%',
    height: 'auto',
    objectFit: 'cover',
  },
}))

const LoginPage = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const history = useHistory()

  const { error, isAttemptingLogin, isAuthenticated } = useSelector((state) => state.authentication)

  const getFormHelperText = useCallback(() => {
    if (error) {
      switch (error.status) {
        case 401:
          return 'Incorrect campus key or password.'
        default:
          return `It appears we are having technical difficulties. Please try again later.`
      }
    }
  }, [error])

  const onLoginFormSubmit = useCallback(
    (campusKey, password, rememberMe) =>
      dispatch({ type: actions.LOGIN_REQUEST, payload: { campusKey, password, rememberMe } }),
    [dispatch]
  )

  useEffect(() => {
    if (isAuthenticated) {
      history.push('/')
    }
  }, [history, isAuthenticated])

  return (
    <Grid className={classes.container} container>
      <Paper className={classes.paper}>
        <Grid container>
          <Hidden lgUp>
            <Grid item>
              <Typography className={classes.heading} color="primary" gutterBottom variant="h1">
                Welcome to JeffQuest!
              </Typography>
              <Typography className={classes.introduction} gutterBottom variant="body1">
                Join the community and best resource to discover and connect with doctors and
                research projects all across campus.
              </Typography>
              <Typography className={classes.introduction} variant="body1">
                Sign in below to find and apply to potential research projects.
              </Typography>
            </Grid>
          </Hidden>
          <Hidden mdDown>
            <Grid item className={classes.imageSide}>
              <img
                className={classes.image}
                alt="Drawing of Researcher"
                src={researchImage}
                srcSet={`${researchImage2x} 2x`}
              />
            </Grid>
          </Hidden>
          <Grid className={classes.formSide} item md={5} xs={12}>
            <Hidden mdDown>
              <Typography className={classes.heading} color="primary" gutterBottom variant="h1">
                Sign In
              </Typography>
              <Typography style={{ fontSize: '1.25rem', letterSpacing: -0.4 }} variant="body1">
                Find and apply to potential research projects.
              </Typography>
            </Hidden>
            <Box mb={3} ml={-3} mr={-3} mt={3}>
              <Divider />
            </Box>
            <LoginForm
              helperText={getFormHelperText()}
              onSubmit={onLoginFormSubmit}
              showLoadingIndicator={isAttemptingLogin}
            />
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  )
}

export default LoginPage
